import { put, call } from "redux-saga/effects";
import { bibleConstants } from "../actions/constants/bibleConstants";
import { BibleService } from "../services/api/bibleService";
import { exceptionHandler } from "../pages/common/functions";

function* bibleSave(request: any) {
	try {
		const result = yield call(BibleService.bibleSave, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: bibleConstants.BibleSaveSuccess,
				payload: res.data,
			});
		}
		else {
			yield put({ type: bibleConstants.BibleSaveFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: bibleConstants.BibleSaveFailure, payload: error });
	}
}

function* bibleGetDetail(request: any) {
	try {
		const result = yield call(BibleService.bibleGetDetail, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: bibleConstants.BibleGetDetailSuccess,
				payload: res.data.bible,
			});
		}
		else {
			yield put({ type: bibleConstants.BibleGetDetailFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: bibleConstants.BibleGetDetailFailure, payload: error });
	}
}

function* bibleGetByFilter(request: any) {
	try {
		const result = yield call(BibleService.bibleGetByFilter, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: bibleConstants.BibleGetByFilterSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: bibleConstants.BibleGetByFilterFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: bibleConstants.BibleGetByFilterFailure, payload: error });
	}
}

function* bibleDelete(request: any) {
	try {
		const result = yield call(BibleService.bibleDelete, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: bibleConstants.BibleDeleteSuccess,
				payload: result.data
			});
		}
		else {
			yield put({ type: bibleConstants.BibleDeleteFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: bibleConstants.BibleDeleteFailure, payload: error });
	}
}

function* bibleGetAll() {
	try {
		const result = yield call(BibleService.bibleGetAll);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: bibleConstants.BibleGetAllSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: bibleConstants.BibleGetAllFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: bibleConstants.BibleGetAllFailure, payload: error });
	}
}

function* bibleTranslationSearch(request: any) {
	try {
		const result = yield call(BibleService.bibleTranslationSearch, request.input, request.version);
		var res = exceptionHandler(result);
		if (res.status) {
			let element = document.createElement("html");
			element.innerHTML = res.data;
			let reading = element.querySelector(".dropdown-display-text")			 
			yield put({
				type: bibleConstants.BibleTranslationSearchSuccess,
				payload: reading?.textContent
			});
		}
		else {
			yield put({
				type: bibleConstants.BibleTranslationSearchFailure,
				payload: res.data
			});
		}
	} catch (e) {
		yield put({ type: bibleConstants.BibleTranslationSearchFailure, payload: e });
	}
}

export const bibleSaga = {
	bibleSave,
	bibleGetDetail,
	bibleGetByFilter,
	bibleDelete,
	bibleGetAll,
	bibleTranslationSearch
}